import React from "react";
import StrategyComparisonChartContent from "../../components/StrategyComparisonChartContent";
import type { V3TimeFilter } from "../../components/performanceChartV3Utils";

type AlphaPerformanceChartContentProps = React.ComponentProps<
  typeof StrategyComparisonChartContent
>;

const AlphaPerformanceChartContent: React.FC<AlphaPerformanceChartContentProps> = (
  props
) => {
  const {
    availableFilters,
    chartData,
    error,
    handleSelectPeriod,
    isDarkMode = false,
    lines,
    loading,
    selectedPeriod,
    showUnavailablePeriods,
    timeFilterOptions,
  } = props;
  const showEmptyWithControls = showUnavailablePeriods
    && !loading
    && !error
    && (chartData.length === 0 || lines.length === 0);

  if (!showEmptyWithControls) {
    return <StrategyComparisonChartContent {...props} />;
  }

  return (
    <div className={`flex flex-col ${isDarkMode ? "text-gray-400" : "text-v7-ink/60"}`}>
      <div className="py-8 text-center">
        <p>No comparison data available for the current selection.</p>
      </div>
      <div className="mt-2 px-1 sm:px-2">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-medium">
          {timeFilterOptions.map((item) => {
            const isAvailable = availableFilters.includes(item.value);
            return (
              <button
                key={item.value}
                type="button"
                onClick={() => handleSelectPeriod(item.value as V3TimeFilter)}
                aria-pressed={selectedPeriod === item.value}
                disabled={!isAvailable}
                className={`border px-2.5 py-1 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-0 ${isDarkMode ? "rounded-full focus:ring-slate-300" : "rounded-v7-control focus:ring-v7-bronze-dark"} ${
                  !isAvailable
                    ? isDarkMode
                      ? "cursor-not-allowed border-slate-800 text-slate-600"
                      : "cursor-not-allowed border-v7-ink/15 text-v7-ink/30"
                    : selectedPeriod === item.value
                      ? isDarkMode
                        ? "border-slate-200 bg-slate-200 text-black shadow-sm"
                        : "border-v7-ink bg-v7-ink text-v7-white shadow-sm"
                      : isDarkMode
                        ? "border-transparent text-slate-300 hover:bg-slate-900 hover:text-white"
                        : "border-transparent text-v7-ink-soft hover:bg-v7-paper hover:text-v7-ink"
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AlphaPerformanceChartContent;
